/**
 * Constants and configuration for shared cart module
 * @module shared-cart/constants
 */

/**
 * Vendors whose inventory is managed in Shopify (no external inventory check needed)
 * @constant {string[]}
 */
export const SHOPIFY_MANAGED_VENDORS = ['loopha'];

/**
 * Domains to exclude from cart export link handling
 * @constant {string[]}
 */
export const CART_EXPORT_IGNORED_DOMAINS = ['deciem.com'];

/**
 * Sister-site domains that should trigger cart export on link click
 * @constant {string[]}
 */
export const SISTER_SITE_DOMAINS = ['theordinary.com', 'niod.com', 'thechemistrybrand.com'];

/**
 * Maximum SKUs per batch request to stay within URL length limits
 * @constant {number}
 */
export const SKU_BATCH_SIZE = 50;

/**
 * SessionStorage key for cart backup before brand switch
 * @constant {string}
 */
export const CART_BACKUP_STORAGE_KEY = 'shared-cart:cart-backup';

/**
 * Maximum age for a cart backup to be considered valid (5 minutes)
 * @constant {number}
 */
export const CART_BACKUP_MAX_AGE_MS = 5 * 60 * 1000;

/**
 * localStorage key for the warehouse-cart-preservation map.
 *
 * must match country-selector-modal/constants.ts — duplicated because Vite
 * IIFE-wraps entries and forbids cross-entry imports.
 * @constant {string}
 */
export const WAREHOUSE_CART_STORAGE_KEY = 'warehouse-cart-preservation:v1';

/**
 * 30-minute TTL on a warehouse-cart entry.
 *
 * must match country-selector-modal/constants.ts — duplicated because Vite
 * IIFE-wraps entries and forbids cross-entry imports.
 * @constant {number}
 */
export const WAREHOUSE_CART_TTL_MS = 30 * 60 * 1000;

/**
 * Schema version stamped onto each warehouse-cart entry.
 *
 * must match country-selector-modal/constants.ts — duplicated because Vite
 * IIFE-wraps entries and forbids cross-entry imports.
 * @constant {number}
 */
export const WAREHOUSE_CART_VERSION = 1;

/**
 * User-friendly error messages
 * @enum {string}
 */
export const UserMessages = {
  OUT_OF_STOCK: 'This item is currently out of stock.',
  PARTIAL_IMPORT: 'Not all products were successfully transferred to LOoPHA.com.',
  DISCOUNT_FAILED: 'Not all discount codes were successfully transferred to LOoPHA.com.',
  RESTORE_FAILED: 'Your cart could not be restored. Please re-add your items.',
  // Shown after the GWP validator removes or trims a gift line. The validator cannot tell
  // WHY the discount stopped applying (cart dropped below the threshold, per-customer cap,
  // country restriction…), so the wording stays neutral about the cause. Canonical wording —
  // gwp-validator/ui.ts carries a parity-tested duplicate (entries are self-contained, no
  // cross-entry imports).
  GIFT_REMOVED: 'A free gift was removed because your cart no longer qualifies for this offer.',
};
